var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPod(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "94px",
    height: "93px",
    viewBox: "0 0 94 93",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "47BF8665-7B85-4A05-AA80-8810936B9BC0@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.3824002%",
    y1: "71.149265%",
    x2: "30.2062508%",
    y2: "24.1884993%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFBF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE2673",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "108.841274%",
    y1: "81.1875535%",
    x2: "-75.5514244%",
    y2: "-4.45332572%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFBF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE2673",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.7033142%",
    y1: "11.5002259%",
    x2: "59.0951282%",
    y2: "102.24808%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE2673",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0397D",
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B67299",
    offset: "40%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB9CAE",
    offset: "67%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEB6BA",
    offset: "88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2.9648049%",
    y1: "-13.5142791%",
    x2: "67.1767406%",
    y2: "69.3427832%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE2673",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2.551382%",
    y1: "57.3125856%",
    x2: "105.327191%",
    y2: "42.7601764%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFBF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE2673",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Jitsi-Box-4",
    transform: "translate(-211.000000, -97.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(183.272336, 78.081172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logoPod",
    transform: "translate(27.950302, 18.948527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.53637257,63.2592006 C6.70394388,47.6617816 13.4675809,37.4952618 21.4329575,31.106423 C29.9606866,15.8334673 51.5303718,13.1296057 64.6801763,22.994838 C71.2585445,24.29516 77.6954599,26.233008 83.9003064,28.781102 C84.6115342,25.7507487 85.1261767,22.6773562 85.4409982,19.580247 C68.1236224,-6.30729691 25.9163706,-6.52360584 8.1290838,18.9235949 C4.34888639,25.0770101 1.76384453,31.892158 0.510362852,39.0094243 C0.168727481,41.5520962 -0.00113577411,44.1150182 0.00193455869,46.6806661 C-0.0463476662,52.3074646 0.809424519,57.9053323 2.53637257,63.2592006 L2.53637257,63.2592006 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9022967,23.0033457 C71.1528478,27.7785498 75.4714104,35.4792437 75.4714104,46.1363848 C75.4689812,47.4654934 75.3956336,48.7934788 75.2516941,50.1144317 C79.2578217,43.5534007 82.1474049,36.3467668 83.7979021,28.8001494 C77.6980244,26.2472935 71.3697581,24.3059047 64.9022967,23.0033457 L64.9022967,23.0033457 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1851433,74.941202 C53.0380628,81.1576627 68.8750409,80.4027517 69.1604613,87.9056424 C82.7295039,80.9188643 92.8349308,67.2072161 92.8349308,46.7629945 C92.8349308,35.8167854 89.9344419,26.8040728 85.1208645,19.7171534 C84.8508722,22.5057021 83.1074932,37.3497168 74.8457282,50.121578 C72.9866382,67.114778 58.9316094,75.4033923 45.1851433,74.941202 Z",
    id: "Path",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0859855,74.2402066 C39.2451675,74.0942727 33.5723446,72.2775826 28.7541821,69.010037 C36.0384282,77.3843988 48.3585063,84.2361494 67.2544259,87.9056424 C67.8473297,87.6315724 68.4325334,87.3422763 69.010037,87.0529801 C68.7328353,79.6378634 52.9246352,80.3839429 45.0859855,74.2402066 Z",
    id: "Path",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0281285,69.4060413 C22.3508428,64.7302119 17.674443,56.9473667 17.674443,46.0422001 C17.5708413,40.8740788 18.8095254,35.7672303 21.2699045,31.2188263 C13.3430235,37.5476493 6.6120742,47.6186663 2.46464418,63.0695655 C2.74062843,63.9113678 3.0472776,64.7455174 3.36925923,65.5567088 C3.38393844,65.5963872 3.40188779,65.6347824 3.42292283,65.6715 C3.73723823,66.4367748 4.06688609,67.2020497 4.41953264,67.9673245 L4.47319624,68.0897685 C4.84117524,68.8550434 5.23981916,69.6203182 5.6154644,70.3167183 L5.6154644,70.3167183 C8.0112781,74.6723715 11.1743945,78.560985 14.9529316,81.7958411 L15.0065952,81.7958411 C15.5892286,82.3009225 16.1871945,82.7830456 16.7928266,83.2498633 L16.938485,83.349349 C17.5211184,83.8008612 18.1267505,84.2294151 18.7323826,84.6426635 L18.8933734,84.7574547 C19.514338,85.1707032 20.1429688,85.5762988 20.7869321,85.966589 L20.886593,86.027811 C24.3045509,88.0655336 27.9675582,89.6623884 31.787971,90.7801678 L32.1099526,90.8720008 C32.7462497,91.0556668 33.3825467,91.2240272 34.02651,91.3847349 L34.5094824,91.4995262 C35.1074483,91.6372756 35.7054142,91.7673724 36.30338,91.8821636 L36.8630148,91.9893021 C37.4456482,92.0964405 38.0359478,92.1959263 38.6185813,92.2801065 L39.2012147,92.3719395 L41.0104448,92.5862165 L41.5317484,92.6397857 C42.1910441,92.7010077 42.858006,92.7469242 43.524968,92.7775352 L43.8546158,92.7775352 C45.4440807,92.8540626 47.0309902,92.8540626 48.6153442,92.7775352 L48.875996,92.7775352 C49.5582904,92.7775352 50.2329186,92.7010077 50.915213,92.6397857 C51.1298674,92.6397857 51.3368556,92.5938692 51.55151,92.570911 C52.1034785,92.5173417 52.6631132,92.4561197 53.2150817,92.3795922 L53.9817047,92.2724538 C54.495342,92.1959263 55.0013132,92.111746 55.5149505,92.0199131 L56.3275708,91.8668581 L57.7918206,91.5530954 L58.6121071,91.3617767 L60.0610245,90.9714865 C60.3293425,90.9026118 60.5899943,90.833737 60.8276474,90.7495568 C61.3336185,90.6041546 61.8319234,90.4434469 62.3608932,90.2750864 C62.5908801,90.1985589 62.8285332,90.1296842 63.0585201,90.045504 C63.6334873,89.8465325 64.2084545,89.6322555 64.7757554,89.4026731 L65.2127305,89.2419654 C65.9793534,88.9435082 66.6616478,88.6373982 67.3669409,88.30833 L67.3669409,88.30833 C48.5463481,84.6809273 36.2803814,77.8317174 29.0281285,69.4060413 Z",
    id: "Path",
    fill: "url(#linearGradient-5)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPod);
export default __webpack_public_path__ + "static/media/LogoPod.08b6133058b51be2a9f32fbe63038c2d.svg";
export { ForwardRef as ReactComponent };